import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CKEditorCompatComponent } from './ckeditor-compat.component';

@NgModule({
  declarations: [CKEditorCompatComponent],
  imports: [CommonModule, FormsModule],
  exports: [CKEditorCompatComponent]
})
export class CKEditorModule {}
